// meant to be used like getURLParam('myParam', window.location.href)
// we're passing in the URL to simplify testing, and to allow param extraction from other strings than just the
// current window location.
export default (paramName: string, fullURL: string): string | null | undefined => {
  return new URL(fullURL).searchParams.get(paramName);
};
